import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router,browserHistory,hashHistory } from 'react-router'

import { LocaleProvider } from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';

import TotalRoutes from './TotalRoutes';
import { AppContainer } from 'react-hot-loader';
import store from './configureStore'
import './styles/index.css';
import {tryLoginUserInfo} from './actions/login';
import {browserJudge} from './utils/NHCore';

var FastClick = require('fastclick');
import 'lodash'

window.baseUrl="api/zhxg-yxxt"
if (process.env.NODE_ENV !== 'production' && process.env.GATEWAY_VERSION) {
    window.gateway_version = process.env.GATEWAY_VERSION;
}

//解决移动端300毫秒延迟
FastClick.attach(document.body);


const render = (Component) => {
    ReactDOM.render(
        <AppContainer>
            <Provider store={store}>
                <LocaleProvider locale={zh_CN}>
                    <Component />
                </LocaleProvider>
            </Provider>
        </AppContainer>,
        document.getElementById('root')
    );
}
//首先判断浏览器内核版本，如果内核版本是IE，直接不让用户访问
browserJudge(()=>{ 
    tryLoginUserInfo(() => {
        render(TotalRoutes)
        if(module.hot) {
            module.hot.accept(TotalRoutes, () => { render(TotalRoutes) });
        }
    });
});





// WEBPACK FOOTER //
// ./index.js